// @flow

import React, { Component, Fragment } from "react";
import { noop } from "lodash";
import { type UnaryFn } from "@tvg/types/Functional";
import Icon from "@fdr/static-ui/Icons";
import { tick } from "@fdr/static-ui/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import { type SortTypeEnum } from "@fdr/types/ProgramPage";
import {
  SortTypesList,
  SortTypeContainer,
  SortTypeWrapper,
  SortType,
  SortOrder
} from "./styled-components";

type Props = {
  sortType: SortTypeEnum,
  onSortTypeClick: UnaryFn<SortTypeEnum, void>
};

export default class RaceCardSort extends Component<Props> {
  static defaultProps = {
    sortType: "odds",
    onSortTypeClick: noop
  };

  renderSortType = (type: SortTypeEnum, isActive: boolean) => (
    <SortTypeContainer onClick={() => this.props.onSortTypeClick(type)}>
      <SortTypeWrapper>
        <div>
          <SortType isActive={isActive}>
            {type === "odds" ? "Odds" : "Saddlecloth Number"}
          </SortType>
          <SortOrder isActive={isActive}> (Low to High)</SortOrder>
        </div>
        {isActive && (
          <Icon size={24} icon={tick} color={buildColor("blue", "500")} />
        )}
      </SortTypeWrapper>
    </SortTypeContainer>
  );

  render() {
    return (
      <SortTypesList>
        <Fragment>
          {this.renderSortType("odds", this.props.sortType === "odds")}
          {this.renderSortType(
            "saddlecloth",
            this.props.sortType === "saddlecloth"
          )}
        </Fragment>
      </SortTypesList>
    );
  }
}
